var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg12D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "heart",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56.33 55.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n        stroke: #87d4e6;\n        stroke-miterlimit: 10;\n        stroke-width: .25px;\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.84,
    y1: 27.85,
    x2: 57.34,
    y2: 27.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0ba1cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#0ca1c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#12a4bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#14a6ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#19a7ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#23a6a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea7a6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.87,16.8l-15.68-.42-3.63,20.62,8.47,.11,3.1-16.52h3.89l-3.26,18.57-25.78,.05s1.05-1.79,3.58-3.21c2.53-1.42,7.73-5.26,8.79-7.05,0,0,2.79-3.21,2.37-7.94,0,0-.32-5.1-7.21-5.16,0,0-8.84-1.05-12.05,4.37l1.37-8.42H7.89s-1.89,3.42-6.52,3.52l-.53,3.05,4.26,.26L1.53,39.26h7.94l-.89,4.63H43.77s6.15,.47,8.31-4.21l3.21-16.89s1.68-4.89-4.42-6ZM10.73,35.89l1.74-10.31,7.89,.16,.58-5.16h3.58l-.26,2.31c-.21,2.16-3.68,4.68-3.68,4.68-7.47,4.26-9.84,8.31-9.84,8.31Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.05,
    y1: 27.68,
    x2: 56.29,
    y2: 27.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41c2ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#41c2ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#41c2ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#42c2cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#1ca7aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42c1c7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_12D",
    "data-name": "12D"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.87,16.8l-15.68-.42-3.63,20.62,8.47,.11,3.1-16.52h3.89l-3.26,18.57-25.78,.05s1.05-1.79,3.58-3.21c2.53-1.42,7.73-5.26,8.79-7.05,0,0,2.79-3.21,2.37-7.94,0,0-.32-5.1-7.21-5.16,0,0-8.84-1.05-12.05,4.37l1.37-8.42H7.89s-1.89,3.42-6.52,3.52l-.53,3.05,4.26,.26L1.53,39.26h7.94l-.89,4.63H43.77s6.15,.47,8.31-4.21l3.21-16.89s1.68-4.89-4.42-6ZM10.73,35.89l1.74-10.31,7.89,.16,.58-5.16h3.58l-.26,2.31c-.21,2.16-3.68,4.68-3.68,4.68-7.47,4.26-9.84,8.31-9.84,8.31Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.05,16.38s.32,1.74,9.36-.58l-3.1,20.2,3.37,2.8s1.1-3.17,1.36-3.64,1.79-8.63,1.79-8.63l-.37-.95,3.84-2.63s3-7.05,10.78-3.95c0,0,3.21,1.68,.79,6.37,0,0-2.16,3.37-8.52,7.26,0,0-6.63,3.63-5.79,8.89h26.46s4.18,.13,3.68-2.71l-12.67-.66,.53-1.16,4.73-2.63,2.74-15.83h7.79s4.42,.21,3.95,3.95l-2.53,14.68s-.11,5.42-8.73,7l-.47,1.68,12.99-.77,2.79-3.44s1.32-28.2,1.47-28.09-20.67-1.79-20.94-1.74-24.83-2.21-24.88-2.26S2.16,12.11,2.16,12.11L.05,16.38Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12D);
export default __webpack_public_path__ + "static/media/12D.115bbea7405b031388715237d76c2ed1.svg";
export { ForwardRef as ReactComponent };